import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Popover from './Popover';

export default class RoomBookingExistingBookingsCalendar extends Component {
  static propTypes = {
    date: PropTypes.string.isRequired,
    existingBookings: PropTypes.object.isRequired,
    halfHours: PropTypes.array.isRequired,
    hidden: PropTypes.bool.isRequired,
    useTimezone: PropTypes.string.isRequired,
    sortedRooms: PropTypes.array.isRequired,
  }

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    $('.BookingCalendar').scrollTop(moment().hours() * 88.5);
  }

  //
  // UI HELPERS
  //

  formattedBookingIncrement(booking) {
    const startTime = this.formattedBookingTimeInTimezone(booking.start_time, 'h:mm A');
    const endTime = this.formattedBookingTimeInTimezone(booking.end_time, 'h:mm A z');
    return `${startTime} - ${endTime}`;
  }

  formattedBookingTimeInTimezone(time, format) {
    return moment(time).tz(this.props.useTimezone).format(format);
  }

  //
  // HELPERS
  //

  getHoursGrid() {
    const grid = {};
    const rooms = this.props.sortedRooms;

    rooms.forEach((roomId) => {
      grid[roomId] = {};
      this.props.halfHours.forEach((halfHour) => {
        grid[roomId][halfHour.format('HH:mm')] = { available: true };
      });

      this.props.existingBookings[roomId].forEach((booking) => {
        const bookingStart = moment(booking.start_time);
        const bookingCurrent = bookingStart.clone();
        const bookingEnd = moment(booking.end_time);

        while (bookingCurrent < bookingEnd) {
          // Deal with old data where end time could be non
          // 30 minute increment
          const halfHourEnd = bookingCurrent.clone().add(30, 'minutes');
          const isEnd = (halfHourEnd.diff(bookingEnd) >= 0);
          grid[roomId][this.formattedBookingTimeInTimezone(bookingCurrent.clone(), 'HH:mm')] = { available: false,
            booking,
            start: bookingCurrent.isSame(bookingStart),
            end: isEnd };
          bookingCurrent.add(30, 'minutes');
        }
      });
    });

    // Include filler columns if there are less than 7 rows
    if (rooms.length < 7) {
      for (let i = 0; i < 7 - rooms.length; i++) {
        const fillerId = `fillerColumn${i}`;
        grid[fillerId] = {};
        this.props.halfHours.forEach((halfHour) => {
          grid[fillerId][halfHour.format('HH:mm')] = { available: true };
        });
      }
    }

    return grid;
  }

  render() {
    const hoursGrid = this.getHoursGrid();
    return (
      <div hidden={this.props.hidden} id="booked-rooms">
        {
          this.props.sortedRooms.map((roomId) => {
            const halfHours = [];
            this.props.halfHours.forEach((halfHour) => {
              const currentHalfHour = hoursGrid[roomId][halfHour.format('HH:mm')];

              if (currentHalfHour.available) {
                halfHours.push(
                  <div
                    className="BookingCalendar-halfHourSlot"
                    key={`${roomId}: ${halfHour.format('h:mm A')}`}
                  />);
              } else {
                const booking = currentHalfHour.booking;

                const triggerClasses = ['BookingCalendar-halfHourSlot--isShown'];

                if (currentHalfHour.start) {
                  triggerClasses.push('BookingCalendar-halfHourSlot--shownStart');
                }
                if (currentHalfHour.end) {
                  triggerClasses.push('BookingCalendar-halfHourSlot--shownEnd');
                }

                halfHours.push(
                  <div
                    className="BookingCalendar-halfHourSlot"
                    key={`${roomId}: ${halfHour.format('h:mm A')}`}
                  >
                    <Popover
                        icon={false}
                        triggerClass={triggerClasses.join(" ")}
                        popoverClass="u-p-5 BookingCalendar-bookingDetails"
                        text={currentHalfHour.start ? booking.company_name : ''}
                      >
                      <p>{booking.title}</p>
                      <p>{booking.user_name}</p>
                      <p>{booking.company_name}</p>
                      <p>{this.formattedBookingIncrement(booking)}</p>
                    </Popover>
                  </div>);
              }
            });

            return <div className="col" key={`${roomId} column`}>{halfHours}</div>;
          })
        }
      </div>
    );
  }
}
